import { render } from "./vote-count-alert.vue?vue&type=template&id=28b6aa98"
import script from "./vote-count-alert.vue?vue&type=script&lang=js"
export * from "./vote-count-alert.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__